(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8386],{

/***/ 3198:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;


/***/ }),

/***/ 5130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ CompanyForm; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(5034);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(4246);
// EXTERNAL MODULE: ../wif-ui-lib/dist/useClickOutside-55c64a80.mjs
var useClickOutside_55c64a80 = __webpack_require__(7720);
// EXTERNAL MODULE: ../node_modules/next/dynamic.js
var dynamic = __webpack_require__(5218);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(7378);
// EXTERNAL MODULE: ./src/constants/locale.ts
var locale = __webpack_require__(3726);
// EXTERNAL MODULE: ./src/contexts/EmployerSiteContext.tsx
var EmployerSiteContext = __webpack_require__(981);
;// CONCATENATED MODULE: ./src/util/clsx.ts
function clsx() {
    for(var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++){
        names[_key] = arguments[_key];
    }
    return names.filter(Boolean).join(" ");
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3444);
// EXTERNAL MODULE: ./src/magnolia/components/CompanyForm/CompanyForm.module.scss
var CompanyForm_module = __webpack_require__(7163);
var CompanyForm_module_default = /*#__PURE__*/__webpack_require__.n(CompanyForm_module);
;// CONCATENATED MODULE: ./src/magnolia/components/CompanyForm/contexts.ts

var CompanyFormContext = (0,react.createContext)(undefined);
var useCompanyFormContext = function() {
    var context = (0,react.useContext)(CompanyFormContext);
    if (context === undefined) {
        throw new Error("useCompanyFormContext must be used within a CompanyForm component");
    }
    return context;
};

;// CONCATENATED MODULE: ./src/magnolia/components/CompanyForm/helpers.ts




var companyFormId = "company-form";
function getCompanyFormClsx() {
    for(var _len = arguments.length, names = new Array(_len), _key = 0; _key < _len; _key++){
        names[_key] = arguments[_key];
    }
    if (!names.length) return getCompanyFormStyleClassName();
    return names.filter(Boolean).map(function(name) {
        return getCompanyFormStyleClassName(name);
    }).join(" ");
}
function getCompanyFormStyleClassName() {
    for(var _len = arguments.length, suffixes = new Array(_len), _key = 0; _key < _len; _key++){
        suffixes[_key] = arguments[_key];
    }
    return (CompanyForm_module_default())[[
        companyFormId
    ].concat((0,_to_consumable_array/* default */.Z)(suffixes)).filter(Boolean).join("__")];
}
function getCompanyFormId() {
    for(var _len = arguments.length, suffixes = new Array(_len), _key = 0; _key < _len; _key++){
        suffixes[_key] = arguments[_key];
    }
    return [
        companyFormId
    ].concat((0,_to_consumable_array/* default */.Z)(suffixes)).filter(Boolean).join("--");
}
function useFormFieldChecks(required, formatRegex) {
    var ref = useCompanyFormContext(), fieldRequiredErrorMessage = ref.fieldRequiredErrorMessage, fieldInvalidFormatErrorMessage = ref.fieldInvalidFormatErrorMessage;
    return (0,react.useMemo)(function() {
        var checks = [];
        if (required) {
            checks.push({
                test: Boolean,
                message: fieldRequiredErrorMessage
            });
        }
        if (formatRegex) {
            checks.push({
                test: formatRegex.test.bind(formatRegex),
                message: fieldInvalidFormatErrorMessage
            });
        }
        return checks;
    }, [
        fieldInvalidFormatErrorMessage,
        fieldRequiredErrorMessage,
        required,
        formatRegex, 
    ]);
}

;// CONCATENATED MODULE: ./src/magnolia/components/CompanyForm/constants.ts
var companyFormDefaultText = {
    // Headings
    heading: "Become a recruitment partner",
    leadText: "You can register your company as a service provider on the workinfinland.fi website.",
    thankYouHeading: "Thank you! We have received your submission.",
    thankYouLeadText: "Our team will review your submission and get back to you shortly.",
    companyIdHeading: "Company identity number",
    companyCriteriaApprovedHeading: "Company criteria approved",
    companyContactHeading: "Company contact information",
    companyServicesHeading: "Description of services",
    companyServicesLeadText: "Please provide a service description and website in at least one language (Finnish, Swedish, or English) that you offer your services in.",
    companyLogoHeading: "Upload Company Logo",
    // Errors
    unmetCriteriaErrorMessage: "Unfortunately, it seems your company does not meet all the criteria.",
    fieldRequiredErrorMessage: "This field is required",
    fieldInvalidFormatErrorMessage: "Invalid format",
    unsupportedFileTypeErrorMessage: "Unsupported file type",
    // Fields
    companyIdLabel: "Company ID",
    companyIdPlaceholder: "Company ID",
    companyNameLabel: "Company name",
    companyNamePlaceholder: "Company name",
    companyPhoneLabel: "Phone number (internal use only)",
    companyPhonePlaceholder: "00 000 0000",
    companyEmailLabel: "Email address (internal use only)",
    companyEmailPlaceholder: "email@address.com",
    companyLogoLeadText: "Please add jpg or webp format max 1 MB.",
    companyLogoUploadAreaCaption: "Drag your image or click to upload",
    typeOfServiceLabel: "Service type (You can select more than one)",
    typeOfServicePlaceholder: "Service type",
    companyDescriptionLabel: "Description",
    companyDescriptionPlaceholder: "Write a service description",
    companyWebsiteLabel: "Website of service",
    companyWebsitePlaceholder: "https://",
    termsField: "I agree to the terms and conditions."
};
var companyIdRegex = /^\d{7}-\d{1}$/;
var companyWebsiteRegex = /^http[s]?:\/\/.+\..+/;
var companyPhoneRegex = /^\+\d+$/;
var companyEmailRegex = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(169);
;// CONCATENATED MODULE: ./src/magnolia/components/CompanyForm/store.ts



var companyFormDefaultState = {
    isLoading: false,
    isDone: false,
    errorMessage: undefined,
    totalSteps: 2,
    currentStep: 1,
    companyId: "",
    companyName: "",
    companyDescription: {},
    companyWebsite: {},
    companyEmail: "",
    companyLogo: undefined,
    companyPhone: "",
    companyServices: [],
    companyTerms: false,
    companyTerms2: false
};
// Context
var StateContext = (0,react.createContext)(companyFormDefaultState);
var DispatchContext = (0,react.createContext)(function() {});
// Hooks
var useCompanyFormDispatch = function() {
    return (0,react.useContext)(DispatchContext);
};
var useCompanyFormState = function() {
    return (0,react.useContext)(StateContext);
};
// Helpers
function companyFormReducer(state, payload) {
    return (0,_object_spread/* default */.Z)({}, state, payload(state));
}
var store_submit = function() {
    return function() {
        return {
            isDone: true,
            isLoading: false,
            errorMessage: undefined
        };
    };
};
var cancel = function() {
    return function() {
        return companyFormDefaultState;
    };
};
var startLoading = function() {
    return function() {
        return {
            isLoading: true,
            errorMessage: undefined
        };
    };
};
var stopLoading = function() {
    return function() {
        return {
            isLoading: false,
            errorMessage: undefined
        };
    };
};
var setErrorMessage = function(errorMessage) {
    return function() {
        return {
            errorMessage: errorMessage,
            isLoading: false
        };
    };
};
var setCompanyId = function(payload) {
    if (!(payload === null || payload === void 0 ? void 0 : payload.companyId)) return function() {
        return {};
    };
    return function() {
        return {
            companyId: payload.companyId,
            companyName: payload.companyName,
            currentStep: 2
        };
    };
};
var setValue = function(partial) {
    return function() {
        return partial !== null && partial !== void 0 ? partial : {};
    };
};
var setWebsite = function(partial) {
    return function(state) {
        var newState = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            companyWebsite: (0,_object_spread/* default */.Z)({}, state.companyWebsite, partial)
        });
        return newState;
    };
};
var setDescription = function(partial) {
    return function(state) {
        var newState = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
            companyDescription: (0,_object_spread/* default */.Z)({}, state.companyDescription, partial)
        });
        return newState;
    };
};
var companyFormActions = {
    cancel: cancel,
    setCompanyId: setCompanyId,
    resetCompanyId: cancel,
    setValue: setValue,
    setWebsite: setWebsite,
    setDescription: setDescription,
    submit: store_submit,
    startLoading: startLoading,
    stopLoading: stopLoading,
    setErrorMessage: setErrorMessage
};

// EXTERNAL MODULE: ../wif-ui-lib/dist/Button-eec2778c.mjs
var Button_eec2778c = __webpack_require__(9358);
// EXTERNAL MODULE: ../node_modules/next-i18next/dist/esm/index.js + 36 modules
var esm = __webpack_require__(9800);
;// CONCATENATED MODULE: ./src/magnolia/components/CompanyForm/components/Actions.tsx






function CompanyFormActions() {
    var t = (0,esm/* useTranslation */.$G)().t;
    var ref = useCompanyFormState(), currentStep = ref.currentStep, isLoading = ref.isLoading;
    var dispatch = useCompanyFormDispatch();
    var onCancel = (0,react.useCallback)(function() {
        dispatch(companyFormActions.cancel());
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: getCompanyFormId("actions"),
        className: getCompanyFormClsx("main", "buttons", currentStep === 1 && "hidden"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_eec2778c.B.Secondary, {
                text: t("form.cancel"),
                disabled: isLoading,
                onClick: onCancel
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_eec2778c.B.Primary, {
                type: "submit",
                text: isLoading ? t("form.submitting") : t("form.submit"),
                disabled: isLoading
            })
        ]
    });
}

// EXTERNAL MODULE: ../wif-ui-lib/dist/main.js
var main = __webpack_require__(128);
;// CONCATENATED MODULE: ./src/magnolia/components/CompanyForm/components/ProgressBar.tsx




function CompanyFormProgressBar() {
    var ref = useCompanyFormState(), currentStep = ref.currentStep, totalSteps = ref.totalSteps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(useClickOutside_55c64a80.B, {
        id: getCompanyFormId("progress"),
        topPadding: useClickOutside_55c64a80.B.Padding.NONE,
        bottomPadding: useClickOutside_55c64a80.B.Padding.SMALL,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useClickOutside_55c64a80.B.Content, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: getCompanyFormClsx("main"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* ProgressBar */.ko, {
                    totalSteps: totalSteps,
                    currentStep: currentStep,
                    ofLabel: undefined,
                    stepLabel: undefined
                })
            })
        })
    });
}

// EXTERNAL MODULE: ../node_modules/next/router.js
var router = __webpack_require__(6677);
// EXTERNAL MODULE: ./src/constants/durations.ts
var durations = __webpack_require__(4780);
;// CONCATENATED MODULE: ./src/hooks/useFormField.ts

function useFormField(options) {
    var _checks = options.checks, checks = _checks === void 0 ? [] : _checks, _defaultValue = options.defaultValue, defaultValue = _defaultValue === void 0 ? "" : _defaultValue, onError = options.onError, onSuccess = options.onSuccess, name = options.name;
    var ref = (0,react.useRef)(null);
    var ref1 = (0,react.useState)(defaultValue), value = ref1[0], setValue = ref1[1];
    var ref2 = (0,react.useState)(false), isDirty = ref2[0], setIsDirty = ref2[1];
    var errors = (0,react.useMemo)(function() {
        return validateValue(value, checks);
    }, [
        value,
        checks
    ]);
    var errorMessage = (0,react.useMemo)(function() {
        return isDirty ? errors === null || errors === void 0 ? void 0 : errors[0] : undefined;
    }, [
        isDirty,
        errors
    ]);
    (0,react.useEffect)(function() {
        if (errorMessage) onError === null || onError === void 0 ? void 0 : onError(errorMessage);
        else onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(value);
    }, [
        errorMessage,
        value,
        onSuccess,
        onError
    ]);
    var onFocus = (0,react.useCallback)(function() {
        setTimeout(function() {
            return setIsDirty(true);
        }, 1000);
    }, []);
    var resetFieldState = (0,react.useCallback)(function() {
        setValue("");
        setIsDirty(false);
    }, []);
    var inputProps = (0,react.useMemo)(function() {
        return {
            value: value,
            onValueChange: setValue,
            onFocus: onFocus,
            name: name,
            ref: ref,
            errorMessage: errorMessage
        };
    }, [
        value,
        onFocus,
        name,
        ref,
        errorMessage
    ]);
    return {
        errorMessage: errorMessage,
        isDirty: isDirty,
        value: value,
        resetFieldState: resetFieldState,
        errors: errors,
        inputProps: inputProps
    };
}
function validateValue(value, checks) {
    var errors = [];
    checks.forEach(function(param) {
        var test = param.test, message = param.message;
        if (!test(value)) errors.push(message);
    });
    return errors;
}

// EXTERNAL MODULE: ./src/hooks/useQuery.ts + 1 modules
var useQuery = __webpack_require__(808);
;// CONCATENATED MODULE: ./src/magnolia/components/CompanyForm/components/Fieldset.tsx


function CompanyFieldset(param) {
    var heading = param.heading, id = param.id, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
        id: getCompanyFormId(id),
        className: getCompanyFormClsx("main", id),
        children: [
            heading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                className: "texts__component_title--bold",
                children: heading
            }) : null,
            children
        ]
    });
}

;// CONCATENATED MODULE: ./src/magnolia/components/CompanyForm/components/CompanyId.tsx















var HtmlParser = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1682).then(__webpack_require__.bind(__webpack_require__, 1682));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1682)
            ];
        }
    }
});
var fieldId = "companyId";
function CompanyIdField(param) {
    var defaultValue = param.value, readOnly = param.readOnly, unmetCriteriaErrorMessage = param.unmetCriteriaErrorMessage, heading = param.heading, _labelText = param.labelText, labelText = _labelText === void 0 ? companyFormDefaultText.companyIdLabel : _labelText, _placeholderText = param.placeholderText, placeholderText = _placeholderText === void 0 ? companyFormDefaultText.companyIdPlaceholder : _placeholderText;
    var t = (0,esm/* useTranslation */.$G)().t;
    var dispatch = useCompanyFormDispatch();
    var ref = useCompanyIdFormField(defaultValue), value = ref.value, errors = ref.errors, inputProps = ref.inputProps, resetFieldState = ref.resetFieldState;
    var ref1 = useCompanyIdValidateQuery(errors.length ? undefined : value, readOnly), isCompanyIdApproved = ref1.isCompanyIdApproved, isCompanyIdChecked = ref1.isCompanyIdChecked, isCompanyIdChecking = ref1.isCompanyIdChecking;
    var iconState = (0,react.useMemo)(function() {
        if (isCompanyIdApproved || readOnly) return "CHECK";
        return value ? "CLEAR" : "SEARCH";
    }, [
        value,
        isCompanyIdApproved,
        readOnly
    ]);
    var handleIconClick = (0,react.useCallback)(function() {
        var ref;
        resetFieldState();
        (ref = inputProps.ref.current) === null || ref === void 0 ? void 0 : ref.focus();
        dispatch(companyFormActions.resetCompanyId());
    }, [
        resetFieldState,
        dispatch,
        inputProps.ref
    ]);
    var isUnmetCriteriaErrorMessageVisible = Boolean(!readOnly && isCompanyIdChecked && !isCompanyIdChecking && !isCompanyIdApproved && unmetCriteriaErrorMessage);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyFieldset, {
        id: fieldId,
        heading: heading,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* TextInput */.oi, (0,_object_spread/* default */.Z)({
                label: labelText,
                placeholder: placeholderText,
                required: true,
                iconState: iconState,
                onIconClick: iconState !== "CHECK" ? handleIconClick : undefined,
                readOnly: readOnly,
                autoComplete: "off",
                helpText: isCompanyIdChecking ? t("form.verifying") : undefined
            }, inputProps)),
            isUnmetCriteriaErrorMessageVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: clsx("texts__lead_text", getCompanyFormStyleClassName(fieldId, "error")),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HtmlParser, {
                    html: unmetCriteriaErrorMessage
                })
            }) : null
        ]
    });
}
function useCompanyIdFormField(defaultValue) {
    var dispatch = useCompanyFormDispatch();
    var checks = useFormFieldChecks(true, companyIdRegex);
    var handleFieldError = (0,react.useCallback)(function() {
        return dispatch(companyFormActions.resetCompanyId());
    }, [
        dispatch
    ]);
    return useFormField({
        name: fieldId,
        defaultValue: defaultValue,
        checks: checks,
        onError: handleFieldError
    });
}
function useCompanyIdValidateQuery(companyId, readOnly) {
    var locale = (0,router.useRouter)().locale;
    var dispatch = useCompanyFormDispatch();
    var ref = (0,react.useState)(false), isCompanyIdApproved = ref[0], setIsCompanyIdApproved = ref[1];
    var handleQuerySuccess = (0,react.useCallback)(function(data) {
        setIsCompanyIdApproved(true);
        dispatch(companyFormActions.setCompanyId(data));
    }, [
        dispatch
    ]);
    var ref1 = (0,useQuery/* default */.Z)("/api/companies/validate-id/?companyId=".concat(companyId, "&locale=").concat(locale), {
        disabled: !companyId || readOnly,
        cacheDurationInMs: durations/* ONE_HOUR_IN_MS */.Vd,
        onSuccess: handleQuerySuccess
    }), isDisabled = ref1.isDisabled, isLoading = ref1.isLoading;
    return {
        isCompanyIdApproved: Boolean(companyId && isCompanyIdApproved),
        isCompanyIdChecked: !isDisabled,
        isCompanyIdChecking: isLoading
    };
}

;// CONCATENATED MODULE: ./src/magnolia/components/CompanyForm/components/Criteria.tsx


var id = "criteria";
function CompanyCriteria(param) {
    var heading = param.heading, criteriaList = param.criteriaList;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
        id: getCompanyFormId(id),
        className: getCompanyFormClsx("aside", id),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFieldsetSubHeading, {
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "texts__caption",
                children: criteriaList.map(function(criteria) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        children: criteria
                    }, criteria);
                })
            })
        ]
    });
}
function CompanyFieldsetSubHeading(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
        className: "texts__body_text--bold",
        children: children
    });
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(7599);
;// CONCATENATED MODULE: ./src/magnolia/components/CompanyForm/components/Contact.tsx










function CompanyName(param) {
    var _labelText = param.labelText, labelText = _labelText === void 0 ? companyFormDefaultText.companyNameLabel : _labelText, _placeholderText = param.placeholderText, placeholderText = _placeholderText === void 0 ? companyFormDefaultText.companyNamePlaceholder : _placeholderText;
    var inputProps = useContactFormField("companyName", true).inputProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* TextInput */.oi, (0,_object_spread/* default */.Z)({
        label: labelText,
        required: true,
        placeholder: placeholderText,
        autoComplete: "off",
        autoFocus: true
    }, inputProps));
}
function CompanyPhone(param) {
    var _labelText = param.labelText, labelText = _labelText === void 0 ? companyFormDefaultText.companyPhoneLabel : _labelText, _placeholderText = param.placeholderText, placeholderText = _placeholderText === void 0 ? companyFormDefaultText.companyPhonePlaceholder : _placeholderText;
    var inputProps = useContactFormField("companyPhone", true, companyPhoneRegex).inputProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* PhoneNumberInput */.AJ, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        label: labelText,
        required: true,
        placeholder: placeholderText,
        autoComplete: "off"
    }, inputProps), {
        height: "large",
        value: undefined
    }));
}
function CompanyEmail(param) {
    var _labelText = param.labelText, labelText = _labelText === void 0 ? companyFormDefaultText.companyEmailLabel : _labelText, _placeholderText = param.placeholderText, placeholderText = _placeholderText === void 0 ? companyFormDefaultText.companyEmailPlaceholder : _placeholderText;
    var inputProps = useContactFormField("companyEmail", true, companyEmailRegex).inputProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* TextInput */.oi, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        label: labelText,
        required: true,
        placeholder: placeholderText,
        autoComplete: "off"
    }, inputProps), {
        inputMode: "email",
        type: "email"
    }));
}
function useContactFormField(name, required, formatRegex) {
    var ref;
    var state = useCompanyFormState();
    var dispatch = useCompanyFormDispatch();
    var checks = useFormFieldChecks(required, formatRegex);
    var onError = (0,react.useCallback)(function() {
        return dispatch(companyFormActions.setValue((0,_define_property/* default */.Z)({}, name, "")));
    }, [
        dispatch,
        name
    ]);
    var onSuccess = (0,react.useCallback)(function(val) {
        return dispatch(companyFormActions.setValue((0,_define_property/* default */.Z)({}, name, val)));
    }, [
        dispatch,
        name
    ]);
    return useFormField({
        name: name,
        onError: onError,
        onSuccess: onSuccess,
        checks: checks,
        defaultValue: (ref = state[name]) === null || ref === void 0 ? void 0 : ref.toString()
    });
}

// EXTERNAL MODULE: ../wif-ui-lib/dist/Dropdown-cd8250f9.mjs
var Dropdown_cd8250f9 = __webpack_require__(3978);
;// CONCATENATED MODULE: ./src/magnolia/components/CompanyForm/components/Services.tsx









function TypeOfServices(param) {
    var services = param.services, _labelText = param.labelText, labelText = _labelText === void 0 ? companyFormDefaultText.typeOfServiceLabel : _labelText, _placeholderText = param.placeholderText, placeholderText = _placeholderText === void 0 ? companyFormDefaultText.typeOfServicePlaceholder : _placeholderText;
    var id = "company__type-of-services";
    var companyServices = useCompanyFormState().companyServices;
    var dispatch = useCompanyFormDispatch();
    var handleItemSelect = (0,react.useCallback)(function(items) {
        dispatch(companyFormActions.setValue({
            companyServices: items
        }));
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: getCompanyFormClsx("form_field"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                htmlFor: id,
                className: "texts__caption",
                children: [
                    labelText,
                    "*"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown_cd8250f9.D, {
                id: id,
                name: "companyServices",
                label: placeholderText,
                items: services,
                size: "large",
                enableCloseOnSelect: false,
                selectedItems: companyServices,
                onSelectedItemsChange: handleItemSelect
            })
        ]
    });
}
function LocalDescription(param) {
    var companyDescriptionField = param.companyDescriptionField, companyWebsiteField = param.companyWebsiteField, locale = param.locale;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: getCompanyFormStyleClassName("services__set"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyDescription, (0,_object_spread/* default */.Z)({
                locale: locale
            }, companyDescriptionField)),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyWebsite, (0,_object_spread/* default */.Z)({
                locale: locale
            }, companyWebsiteField))
        ]
    });
}
function CompanyDescription(param) {
    var _labelText = param.labelText, labelText = _labelText === void 0 ? companyFormDefaultText.companyDescriptionLabel : _labelText, _placeholderText = param.placeholderText, placeholderText = _placeholderText === void 0 ? companyFormDefaultText.companyDescriptionPlaceholder : _placeholderText, locale = param.locale, _maxLength = param.maxLength, maxLength = _maxLength === void 0 ? "500" : _maxLength;
    var ref, ref1;
    var state = useCompanyFormState();
    var dispatch = useCompanyFormDispatch();
    var name = "companyDescription";
    var id = "".concat((0,react.useId)(), "__").concat(name, "-").concat(locale);
    var value = ((ref = state.companyDescription) === null || ref === void 0 ? void 0 : (ref1 = ref[locale]) === null || ref1 === void 0 ? void 0 : ref1.toString()) || "";
    var handleChange = (0,react.useCallback)(function(value) {
        return dispatch(companyFormActions.setDescription((0,_define_property/* default */.Z)({}, locale, value)));
    }, [
        dispatch,
        locale
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: getCompanyFormClsx("form_field"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* Textarea */.gx, {
            label: "".concat(labelText, " (").concat(locale.toUpperCase(), ")"),
            id: id,
            maxLength: parseInt(maxLength, 10),
            name: "".concat(name, "-").concat(locale),
            value: value,
            onValueChange: handleChange,
            placeholder: placeholderText
        })
    });
}
function CompanyWebsite(param) {
    var _labelText = param.labelText, labelText = _labelText === void 0 ? companyFormDefaultText.companyWebsiteLabel : _labelText, _placeholderText = param.placeholderText, placeholderText = _placeholderText === void 0 ? companyFormDefaultText.companyWebsitePlaceholder : _placeholderText, locale = param.locale;
    var name = "companyWebsite";
    var dispatch = useCompanyFormDispatch();
    var checks = useFormFieldChecks(false, companyWebsiteRegex);
    var onError = (0,react.useCallback)(function() {
        return dispatch(companyFormActions.setWebsite((0,_define_property/* default */.Z)({}, locale, "")));
    }, [
        dispatch,
        locale
    ]);
    var onSuccess = (0,react.useCallback)(function(value) {
        return dispatch(companyFormActions.setWebsite((0,_define_property/* default */.Z)({}, locale, value)));
    }, [
        dispatch,
        locale
    ]);
    var inputProps = useFormField({
        name: "".concat(name, "-").concat(locale),
        onError: onError,
        onSuccess: onSuccess,
        checks: checks
    }).inputProps;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* TextInput */.oi, (0,_object_spread/* default */.Z)({
        label: labelText + " (".concat(locale.toUpperCase(), ")"),
        required: false,
        placeholder: placeholderText,
        autoComplete: "off"
    }, inputProps));
}

;// CONCATENATED MODULE: ./src/magnolia/components/CompanyForm/components/Logo.tsx







var ONE_MB_IN_BYTES = 1024 * 1024;
var supportedMimeTypes = [
    "image/jpeg",
    "image/png"
];
function CompanyLogo(param) {
    var heading = param.heading, _leadText = param.leadText, leadText = _leadText === void 0 ? companyFormDefaultText.companyLogoLeadText : _leadText, _uploadAreaCaption = param.uploadAreaCaption, uploadAreaCaption = _uploadAreaCaption === void 0 ? companyFormDefaultText.companyLogoUploadAreaCaption : _uploadAreaCaption, unsupportedFileTypeErrorMessage = param.unsupportedFileTypeErrorMessage;
    var dispatch = useCompanyFormDispatch();
    var companyLogo = useCompanyFormState().companyLogo;
    var t = (0,esm/* useTranslation */.$G)().t;
    var handleFileChange = (0,react.useCallback)(function(file) {
        dispatch(companyFormActions.setValue({
            companyLogo: file
        }));
    }, [
        dispatch
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyFieldset, {
        id: "logo",
        heading: heading,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: leadText
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* MediaUpload */.R, {
                name: "companyLogo",
                caption: uploadAreaCaption,
                value: companyLogo,
                onChange: handleFileChange,
                maxFileSize: ONE_MB_IN_BYTES,
                supportedMimeTypes: supportedMimeTypes,
                i18n: {
                    browseFilesLabel: t("form.browseFiles"),
                    maximumSizeLabel: t("form.maximumSize"),
                    optionalLabel: t("form.optional"),
                    unsupportedFileTypeError: unsupportedFileTypeErrorMessage
                }
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/magnolia/components/CompanyForm/components/Terms.tsx





var Terms_HtmlParser = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1682).then(__webpack_require__.bind(__webpack_require__, 1682));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1682)
            ];
        }
    }
});
function CompanyTerms(param) {
    var terms = param.terms, terms2 = param.terms2;
    var state = useCompanyFormState();
    var dispatch = useCompanyFormDispatch();
    var handleChange = function(checked) {
        dispatch(companyFormActions.setValue({
            companyTerms: checked
        }));
    };
    var handleChange2 = function(checked) {
        dispatch(companyFormActions.setValue({
            companyTerms2: checked
        }));
    };
    var _companyTerms, _companyTerms2;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyFieldset, {
        id: "terms",
        heading: "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* Checkbox */.XZ, {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Terms_HtmlParser, {
                    html: terms
                }),
                name: "companyTerms",
                checked: (_companyTerms = state.companyTerms) !== null && _companyTerms !== void 0 ? _companyTerms : false,
                onChange: handleChange,
                onDarkBackground: true,
                required: true,
                error: !state.companyTerms
            }),
            !!terms2 && /*#__PURE__*/ (0,jsx_runtime.jsx)(main/* Checkbox */.XZ, {
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Terms_HtmlParser, {
                    html: terms2
                }),
                name: "companyTerms2",
                checked: (_companyTerms2 = state.companyTerms2) !== null && _companyTerms2 !== void 0 ? _companyTerms2 : false,
                onChange: handleChange2,
                onDarkBackground: true,
                required: true,
                error: !state.companyTerms2
            })
        ]
    });
}

// EXTERNAL MODULE: ../wif-ui-lib/dist/useModal-5a548e10.mjs
var useModal_5a548e10 = __webpack_require__(8175);
// EXTERNAL MODULE: ../wif-ui-lib/dist/BottomSheet-e2c6dc93.mjs
var BottomSheet_e2c6dc93 = __webpack_require__(9675);
// EXTERNAL MODULE: ../wif-ui-lib/dist/PageHeader.js
var PageHeader = __webpack_require__(9792);
;// CONCATENATED MODULE: ./src/magnolia/components/CompanyForm/components/Header.tsx






var Header_HtmlParser = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1682).then(__webpack_require__.bind(__webpack_require__, 1682));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1682)
            ];
        }
    }
});
function CompanyFormHeader(param) {
    var heading = param.heading, leadText = param.leadText, instructions = param.instructions;
    var isEmployerSite = (0,EmployerSiteContext/* default */.Z)().isEmployerSite;
    var ref = (0,useModal_5a548e10.u)(), isModalOpen = ref.isModalOpen, openModal = ref.openModal, closeModal = ref.closeModal;
    var leadTextElement = instructions ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        onClick: openModal,
        style: {
            cursor: "pointer"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HtmlParser, {
            html: leadText
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HtmlParser, {
        html: leadText
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* PageHeader */.m, {
                id: getCompanyFormId("header"),
                heading: heading,
                leadText: leadTextElement,
                backgroundColor: isEmployerSite ? "blue" : "lightBlue"
            }),
            instructions ? /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomSheet_e2c6dc93.B, {
                isVisible: isModalOpen,
                closeModal: closeModal,
                heading: instructions.heading,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header_HtmlParser, {
                    html: instructions.content
                })
            }) : null
        ]
    });
}

;// CONCATENATED MODULE: ./src/magnolia/components/CompanyForm/components/ThankYou.tsx






var ThankYou_HtmlParser = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1682).then(__webpack_require__.bind(__webpack_require__, 1682));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1682)
            ];
        }
    }
});
function ThankYou(param) {
    var id = param.id, className = param.className, heading = param.heading, leadText = param.leadText;
    var isEmployerSite = (0,EmployerSiteContext/* default */.Z)().isEmployerSite;
    var ref = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var ref1;
        (ref1 = ref.current) === null || ref1 === void 0 ? void 0 : ref1.scrollIntoView({
            behavior: "smooth"
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: id,
        className: className,
        ref: ref,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* PageHeader */.m, {
            id: getCompanyFormId("header"),
            heading: heading,
            leadText: /*#__PURE__*/ (0,jsx_runtime.jsx)(ThankYou_HtmlParser, {
                html: leadText
            }),
            backgroundColor: isEmployerSite ? "blue" : "lightBlue"
        })
    }, id);
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(5963);
// EXTERNAL MODULE: ../wif-ui-lib/dist/index-615eb227.mjs
var index_615eb227 = __webpack_require__(8517);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(3842);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(5556);
;// CONCATENATED MODULE: ./src/hooks/useMutation.ts






var MutationStatus;
(function(MutationStatus) {
    MutationStatus["INIT"] = "init";
    MutationStatus["LOADING"] = "loading";
    MutationStatus["SUCCESS"] = "success";
    MutationStatus["ERROR"] = "error";
    MutationStatus["CANCELLED"] = "cancelled";
})(MutationStatus || (MutationStatus = {}));
/**
 * Hook to handle fetch requests with error handling and cache.
 *
 * @examples
 * - default
 *   ```tsx
 *   const { mutate } = useMutation<JobsData>("/jobs");
 *   ```
 */ function useMutation(url) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var mutationUrl = url.toString();
    var onLoading = options.onLoading, onSuccess = options.onSuccess, onError = options.onError, onDone = options.onDone;
    var abortControllerRef = (0,react.useRef)();
    var ref = (0,react.useTransition)(), startTransition = ref[1];
    var ref1 = (0,react.useState)(MutationStatus.INIT), status = ref1[0], setStatus = ref1[1];
    var ref2 = (0,react.useState)(undefined), data = ref2[0], setData = ref2[1];
    var ref3 = (0,react.useState)(undefined), errorMsg = ref3[0], setErrorMsg = ref3[1];
    var handleLoading = (0,index_615eb227.a)(function() {
        startTransition(function() {
            setErrorMsg(undefined);
        });
        startTransition(function() {
            onLoading === null || onLoading === void 0 ? void 0 : onLoading();
            setStatus(MutationStatus.LOADING);
        });
    });
    var handleSuccess = (0,index_615eb227.a)(function(data) {
        startTransition(function() {
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data);
            setData(data);
            setErrorMsg(undefined);
            setStatus(MutationStatus.SUCCESS);
        });
    });
    var handleError = (0,index_615eb227.a)(function(error) {
        startTransition(function() {
            setErrorMsg(error.message);
            var errorStatus = error.name === "AbortError" ? MutationStatus.CANCELLED : MutationStatus.ERROR;
            setStatus(errorStatus);
            if (errorStatus === MutationStatus.ERROR && onError) {
                onError(error);
            }
        });
    });
    var handleDone = (0,index_615eb227.a)(function() {
        return onDone === null || onDone === void 0 ? void 0 : onDone();
    });
    var mutate = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var options, // cancel the previous request before new request
        ref, abortController, handleResponse, request;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            options = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
            (ref = abortControllerRef.current) === null || ref === void 0 ? void 0 : ref.abort();
            abortController = new AbortController();
            abortControllerRef.current = abortController;
            handleLoading();
            handleResponse = function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(response) {
                    var data;
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    response.json()
                                ];
                            case 1:
                                data = _state.sent();
                                if (abortController.signal.aborted) throw new DOMException("Aborted while handling response", "AbortError");
                                return [
                                    2,
                                    data
                                ];
                        }
                    });
                });
                return function handleResponse(response) {
                    return _ref.apply(this, arguments);
                };
            }();
            request = new Request(mutationUrl, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, options), {
                signal: abortController.signal
            }));
            fetch(request).then(handleResponse).then(handleSuccess).catch(handleError).finally(handleDone);
            return [
                2
            ];
        });
    }), [
        mutationUrl,
        handleLoading,
        handleSuccess,
        handleError,
        handleDone
    ]);
    var cancelMutation = (0,react.useCallback)(function() {
        var ref;
        (ref = abortControllerRef.current) === null || ref === void 0 ? void 0 : ref.abort();
    }, []);
    return {
        status: status,
        data: data,
        errorMsg: errorMsg,
        mutate: mutate,
        cancel: cancelMutation,
        isInit: status === MutationStatus.INIT,
        isSuccess: status === MutationStatus.SUCCESS,
        isError: status === MutationStatus.ERROR,
        isLoading: status === MutationStatus.LOADING
    };
}

;// CONCATENATED MODULE: ./src/magnolia/components/CompanyForm/useSubmit.ts





var companyLogoFieldName = "companyLogo";
function useSubmit(dispatch) {
    var mutate = useMutation("/api/companies/form-submit/", {
        onLoading: (0,index_615eb227.a)(function() {
            return dispatch(companyFormActions.startLoading());
        }),
        onSuccess: (0,index_615eb227.a)(function(data) {
            if (data && typeof data === "string" && data !== "OK") {
                return dispatch(companyFormActions.setErrorMessage(data));
            } else {
                dispatch(companyFormActions.submit());
            }
        }),
        onError: (0,index_615eb227.a)(function() {
            dispatch(companyFormActions.stopLoading());
        })
    }).mutate;
    return (0,react.useCallback)(function(e) {
        e.preventDefault();
        var formData = new FormData(e.currentTarget);
        var logoFile = formData.get(companyLogoFieldName);
        if ((0,_instanceof/* default */.Z)(logoFile, File) && logoFile.size === 0) {
            formData.delete(companyLogoFieldName);
        }
        mutate({
            method: "POST",
            body: formData
        });
    }, [
        mutate
    ]);
}

;// CONCATENATED MODULE: ./src/magnolia/components/CompanyForm/components/ErrorMessage.tsx



function ErrorMessage(props) {
    var errorMessage = useCompanyFormState().errorMessage;
    if (!errorMessage) return null;
    var message = String(props["".concat(errorMessage, "ErrorMessage")] || errorMessage);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: getCompanyFormClsx("main", "error") + " texts__body_text--bold",
        children: message
    });
}

;// CONCATENATED MODULE: ./src/magnolia/components/CompanyForm/CompanyForm.tsx

























var CompanyForm_HtmlParser = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1682).then(__webpack_require__.bind(__webpack_require__, 1682));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1682)
            ];
        }
    }
});
function CompanyForm(props) {
    var _heading = props.heading, heading = _heading === void 0 ? companyFormDefaultText.heading : _heading, _leadText = props.leadText, leadText = _leadText === void 0 ? companyFormDefaultText.leadText : _leadText, _thankYouHeading = props.thankYouHeading, thankYouHeading = _thankYouHeading === void 0 ? companyFormDefaultText.thankYouHeading : _thankYouHeading, _thankYouLeadText = props.thankYouLeadText, thankYouLeadText = _thankYouLeadText === void 0 ? companyFormDefaultText.thankYouLeadText : _thankYouLeadText, _fieldRequiredErrorMessage = props.fieldRequiredErrorMessage, fieldRequiredErrorMessage = _fieldRequiredErrorMessage === void 0 ? companyFormDefaultText.fieldRequiredErrorMessage : _fieldRequiredErrorMessage, _unmetCriteriaErrorMessage = props.unmetCriteriaErrorMessage, unmetCriteriaErrorMessage = _unmetCriteriaErrorMessage === void 0 ? companyFormDefaultText.unmetCriteriaErrorMessage : _unmetCriteriaErrorMessage, _fieldInvalidFormatErrorMessage = props.fieldInvalidFormatErrorMessage, fieldInvalidFormatErrorMessage = _fieldInvalidFormatErrorMessage === void 0 ? companyFormDefaultText.fieldInvalidFormatErrorMessage : _fieldInvalidFormatErrorMessage, _unsupportedFileTypeErrorMessage = props.unsupportedFileTypeErrorMessage, unsupportedFileTypeErrorMessage = _unsupportedFileTypeErrorMessage === void 0 ? companyFormDefaultText.unsupportedFileTypeErrorMessage : _unsupportedFileTypeErrorMessage, _companyIdHeading = props.companyIdHeading, companyIdHeading = _companyIdHeading === void 0 ? companyFormDefaultText.companyIdHeading : _companyIdHeading, _companyCriteriaApprovedHeading = props.companyCriteriaApprovedHeading, companyCriteriaApprovedHeading = _companyCriteriaApprovedHeading === void 0 ? companyFormDefaultText.companyCriteriaApprovedHeading : _companyCriteriaApprovedHeading, _companyContactHeading = props.companyContactHeading, companyContactHeading = _companyContactHeading === void 0 ? companyFormDefaultText.companyContactHeading : _companyContactHeading, _companyLogoHeading = props.companyLogoHeading, companyLogoHeading = _companyLogoHeading === void 0 ? companyFormDefaultText.companyLogoHeading : _companyLogoHeading, _companyServicesHeading = props.companyServicesHeading, companyServicesHeading = _companyServicesHeading === void 0 ? companyFormDefaultText.companyServicesHeading : _companyServicesHeading, _companyServicesLeadText = props.companyServicesLeadText, companyServicesLeadText = _companyServicesLeadText === void 0 ? companyFormDefaultText.companyServicesLeadText : _companyServicesLeadText, instructions = props.instructions, companyIdField = props.companyIdField, companyEmailField = props.companyEmailField, companyNameField = props.companyNameField, companyPhoneField = props.companyPhoneField, companyLogoField = props.companyLogoField, typeOfServiceField = props.typeOfServiceField, companyDescriptionField = props.companyDescriptionField, companyWebsiteField = props.companyWebsiteField, _companyTermsField = props.companyTermsField, companyTermsField = _companyTermsField === void 0 ? companyFormDefaultText.termsField : _companyTermsField, companyTermsField2 = props.companyTermsField2, _services = props.services, services = _services === void 0 ? [] : _services, _companyApprovalCriteriaList = props.companyApprovalCriteriaList, companyApprovalCriteriaList = _companyApprovalCriteriaList === void 0 ? [] : _companyApprovalCriteriaList;
    var isEmployerSite = (0,EmployerSiteContext/* default */.Z)().isEmployerSite;
    var ref = (0,react.useReducer)(companyFormReducer, companyFormDefaultState), state = ref[0], dispatch = ref[1];
    var handleFormSubmit = useSubmit(dispatch);
    var id = getCompanyFormId();
    var className = clsx(getCompanyFormClsx(), isEmployerSite ? getCompanyFormClsx("employers") : "");
    if (state.isDone) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ThankYou, {
            id: id,
            className: className,
            heading: thankYouHeading,
            leadText: thankYouLeadText
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: id,
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFormContext.Provider, {
            value: {
                fieldRequiredErrorMessage: fieldRequiredErrorMessage,
                fieldInvalidFormatErrorMessage: fieldInvalidFormatErrorMessage
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DispatchContext.Provider, {
                value: dispatch,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StateContext.Provider, {
                    value: state,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFormHeader, {
                            heading: heading,
                            leadText: leadText,
                            instructions: instructions
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFormProgressBar, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(useClickOutside_55c64a80.B, {
                            as: "form",
                            id: getCompanyFormId("fields"),
                            topPadding: useClickOutside_55c64a80.B.Padding.NONE,
                            bottomPadding: useClickOutside_55c64a80.B.Padding.SMALL,
                            onSubmit: handleFormSubmit,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(useClickOutside_55c64a80.B.Content, {
                                children: state.currentStep === 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyIdField, (0,_object_spread/* default */.Z)({
                                    heading: companyIdHeading,
                                    unmetCriteriaErrorMessage: unmetCriteriaErrorMessage
                                }, companyIdField), 1) : state.currentStep === 2 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyIdField, (0,_object_spread/* default */.Z)({
                                            heading: companyIdHeading,
                                            value: state.companyId,
                                            readOnly: true
                                        }, companyIdField), 2),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyCriteria, {
                                            heading: companyCriteriaApprovedHeading,
                                            criteriaList: companyApprovalCriteriaList
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyFieldset, {
                                            id: "contact",
                                            heading: companyContactHeading,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyName, (0,_object_spread/* default */.Z)({}, companyNameField)),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyPhone, (0,_object_spread/* default */.Z)({}, companyPhoneField)),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyEmail, (0,_object_spread/* default */.Z)({}, companyEmailField))
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyFieldset, {
                                            id: "services",
                                            heading: companyServicesHeading,
                                            children: [
                                                services.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TypeOfServices, (0,_object_spread/* default */.Z)({
                                                    services: services
                                                }, typeOfServiceField)) : null,
                                                companyServicesLeadText && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "texts__lead_text",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyForm_HtmlParser, {
                                                        html: companyServicesLeadText
                                                    })
                                                }),
                                                locale/* localesEmployers.map */.HG.map(function(locale) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalDescription, {
                                                        companyDescriptionField: companyDescriptionField,
                                                        companyWebsiteField: companyWebsiteField,
                                                        locale: locale
                                                    }, locale);
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyLogo, (0,_object_spread/* default */.Z)({
                                            heading: companyLogoHeading,
                                            unsupportedFileTypeErrorMessage: unsupportedFileTypeErrorMessage
                                        }, companyLogoField)),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyTerms, {
                                            terms: companyTermsField,
                                            terms2: companyTermsField2
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyFormActions, {}),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessage, (0,_object_spread/* default */.Z)({}, props))
                                    ]
                                }) : null
                            })
                        })
                    ]
                })
            })
        })
    }, id);
}

;// CONCATENATED MODULE: ./src/magnolia/components/CompanyForm/index.ts



/***/ }),

/***/ 7163:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"company-form":"CompanyForm_company-form__2HX20","company-form__employers":"CompanyForm_company-form__employers__cUV_a","company-form__main":"CompanyForm_company-form__main__KYXbm","company-form__aside":"CompanyForm_company-form__aside__D3xOh","company-form__contact":"CompanyForm_company-form__contact__wFowF","company-form__services":"CompanyForm_company-form__services___1Inx","company-form__logo":"CompanyForm_company-form__logo__TlJNX","company-form__companyId":"CompanyForm_company-form__companyId__Idu6Z","company-form__terms":"CompanyForm_company-form__terms__QGP1i","company-form__companyId__error":"CompanyForm_company-form__companyId__error__g9PRP","company-form__criteria":"CompanyForm_company-form__criteria__ci3G_","company-form__services__set":"CompanyForm_company-form__services__set__RLyWV","company-form__form_field":"CompanyForm_company-form__form_field__hxmjd","company-form__buttons":"CompanyForm_company-form__buttons__SxEDg","company-form__hidden":"CompanyForm_company-form__hidden__rmEdC","company-form__error":"CompanyForm_company-form__error__qxJ9z"};

/***/ }),

/***/ 9792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ E; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(403);
/* harmony import */ var _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7720);



const i = "page-header", H = "page-header--blue", m = "page-header--light-blue", u = "page-header__heading", h = "desktop", B = "page-header__lead-text", t = {
  pageHeader: i,
  pageHeaderBlue: H,
  pageHeaderLightBlue: m,
  pageHeaderHeading: u,
  desktop: h,
  pageHeaderLeadText: B
};
function E({
  heading: n,
  leadText: r,
  backgroundColor: o,
  children: g,
  className: l,
  ...s
}) {
  const c = o === "lightBlue" ? t.pageHeaderLightBlue : t.pageHeaderBlue;
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_1__.B,
    {
      "data-testid": "page-header",
      className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(t.pageHeader, c, l),
      topPadding: _useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Padding.SMALL,
      ...s
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Content, { itemScope: !0 }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("h1", { className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.t.pageHeading, t.pageHeaderHeading) }, n)),
    r && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Content, { itemScope: !0 }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "div",
      {
        className: (0,_useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.c)(
          _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsComponentTitle,
          t.pageHeaderLeadText
        )
      },
      r
    )),
    g ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_useClickOutside_55c64a80_mjs__WEBPACK_IMPORTED_MODULE_1__.B.Content, null, g) : null
  );
}

//# sourceMappingURL=PageHeader.js.map


/***/ }),

/***/ 3842:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 5963:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ }),

/***/ 9675:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ x; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7378);
/* harmony import */ var _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(403);
/* harmony import */ var _useModal_5a548e10_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8175);
/* harmony import */ var _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2007);
/* harmony import */ var _Button_eec2778c_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9358);





const i = "bottom-sheet", S = "mobile", p = "desktop", d = "bottom-sheet__backdrop", _ = "bottom-sheet__header", f = "bottom-sheet__close-button", u = "bottom-sheet__main", B = "bottom-sheet__footer", e = {
  bottomSheet: i,
  mobile: S,
  desktop: p,
  bottomSheetBackdrop: d,
  bottomSheetHeader: _,
  bottomSheetCloseButton: f,
  bottomSheetMain: u,
  bottomSheetFooter: B
};
function x({
  isVisible: a,
  closeModal: o,
  heading: s,
  children: n,
  closeLabel: m = "Close"
}) {
  return a ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
    _useModal_5a548e10_mjs__WEBPACK_IMPORTED_MODULE_1__.M,
    {
      closeModal: o,
      className: e.bottomSheet,
      backdropClassName: e.bottomSheetBackdrop
    },
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("header", { className: e.bottomSheetHeader }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("h2", { className: _useKeyDown_88662051_mjs__WEBPACK_IMPORTED_MODULE_2__.t.textsComponentTitleBold }, s), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(
      "button",
      {
        className: e.bottomSheetCloseButton,
        onClick: o,
        title: m
      },
      /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_3__.I, { icon: _Icon_e01b6482_mjs__WEBPACK_IMPORTED_MODULE_3__.W.CLOSE, size: 20 })
    )),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: e.bottomSheetMain }, n),
    /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("footer", { className: e.bottomSheetFooter }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Button_eec2778c_mjs__WEBPACK_IMPORTED_MODULE_4__.B.Secondary, { text: m, onClick: o }))
  ) : null;
}

//# sourceMappingURL=BottomSheet-e2c6dc93.mjs.map


/***/ })

}]);